"use client";

import SignUser from "@/components/sign/user";
import { sharedHeaderSignInButtonClassName } from "@/components/sign/styles";
import { useAppContext } from "@/contexts/app";
import { isAuthEnabled } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

interface SiteHeaderAuthProps {
  className?: string;
}

export default function SiteHeaderAuth({ className }: SiteHeaderAuthProps) {
  const t = useTranslations();
  const { user, setShowSignModal } = useAppContext();

  if (!isAuthEnabled()) {
    return null;
  }

  if (user) {
    return <SignUser user={user} isAdmin={user.isAdmin} />;
  }

  return (
    <button
      type="button"
      onClick={() => setShowSignModal(true)}
      data-testid="shared-sign-in-button"
      className={cn(className, sharedHeaderSignInButtonClassName)}
    >
      {t("user.sign_in")}
    </button>
  );
}
